import React, { useEffect, useState } from "react";
import { postConsentimientoInformado, postGuardarConsentimientoInformadoUsuario, postInformacionConsentimientoInformado } from "../services/PaginaRuta";
import {PDFDownloadLink} from '@react-pdf/renderer'
import ConsentimientoPDF from "./ConsentimientoPDF";
import ModalFirmaConsentimientoInformado from "../components/cirugia/reservarCx/ModalFirmaConsentimientoInformado";
import { fechaActual } from "../hooks/UseDate";

const ModalConsentimientoInformado = ({
  setmodalOnConsentimientoInformado,
  user,
  setactualizarData
}) => {
    const [dataDescripcion, setdataDescripcion]=useState([])
    const [selectDescripcion, setselectDescripcion]=useState('')
    const [informacionConsentimiento, setinformacionConsentimiento]=useState([])
    const [textConsentimiento, settextConsentimiento]= useState('')
    const [modalOnFirma, setmodalOnFirma]=useState(false)
    const [tagFirma, settagFirma]=useState('')
    const [nombreQuienFirma, setnombreQuienFirma]=useState('')
    const [arrayFirmas, setarrayFirmas]=useState([])
    const [loading, setloading]=useState(true)
  const handleCancelarClick = () => {
    setmodalOnConsentimientoInformado(false);
  };

  useEffect(()=>{
    setarrayFirmas([])
    const body={
        varConEstDoc:'S'
    }
    setloading(false)
    postConsentimientoInformado(body).then((res)=>{
      setloading(true)
        setdataDescripcion(res.data)
    })
  },[])

  const handleOnsubmitDescripcion=(e)=>{
    //e.preventDefault()
    //console.log(e.target.value, 'descripcion')
    setselectDescripcion(e.target.value)
    const body={
      varConCodDoc:parseInt(e.target.value)
    }
    if(e.target.value !== 'Sin seleccionar'){
      postInformacionConsentimientoInformado(body).then((res)=>{        
        let userConsentimient = res.data[0].ConDetDoc.replace(/#\?NOMBRE\?#/g, user.MPNOMC);        
        userConsentimient = userConsentimient.replace(/#\?DOCUMENTO\?#/g,user.MPCedu)        
        userConsentimient = userConsentimient.replace(/#\?DOCUMENTOS\?#/g,user.MPCedu)        
        setinformacionConsentimiento(res.data[0])
        settextConsentimiento(userConsentimient)
      })
    }else{
      setinformacionConsentimiento({
        ConCodDoc:'',
        ConDesDoc:''
      })
      settextConsentimiento('')
    }
  }

  const handleOnchangeModificar=(e)=>{
    settextConsentimiento(e.target.value)
  }

  
  // const handleClickFirmaPaciente=()=>{
  //   settagFirma('#?FIRMA_PACIENTE?#')
  //   setnombreQuienFirma('Guardar Firma Paciente')
  //   setmodalOnFirma(true)
  // }

  // const handleClickFirmaAcudiente=()=>{
  //   settagFirma('#?FIRMA_ACUDIENTE?#')
  //   setnombreQuienFirma('Guardar Firma Acudiente')
  //   setmodalOnFirma(true)
  // }

  // const handleClickFirmaMedico=()=>{
  //   settagFirma('#?FIRMA_MEDICO?#')
  //   setnombreQuienFirma('Guardar Firma Medico')
  //   setmodalOnFirma(true)
  // }

  // const handleClickFirmaOtro=()=>{
  //   settagFirma('#?FIRMA_OTRO?#')
  //   setnombreQuienFirma('Guardar Firma Otro')
  //   setmodalOnFirma(true)
  // }

  const handleOnclickGuardarConsentimientoInformado=()=>{
    const guardarConsentimiento={
      "codigo_consentimiento": informacionConsentimiento.ConCodDoc,
      "tipo_documento":user.MPTDoc,
      "numero_documento": user.MPCedu ,
      "nombre_paciente" :user.MPNOMC ,
      "fecha": fechaActual(),
      "texto":textConsentimiento,
      "firma":'',
      "tag":'',
      "nombre_consentimiento":informacionConsentimiento.ConDesDoc,
      "ProCirCod":user.ProCirCod,
      "Activo": 'Si'
    }
    setloading(false)
    postGuardarConsentimientoInformadoUsuario(guardarConsentimiento).then((res)=>{ 
        setloading(true)
        setactualizarData(guardarConsentimiento)
        setmodalOnConsentimientoInformado(false)
    })
  }

  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-7xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Consentimiento Informado*
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-1">
            
              <div className="flex py-2 text-left">
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Código Consentimiento Inf.
                  </label>
                  <div className="flex">
                    <input
                      disabled={true}
                      defaultValue={informacionConsentimiento.ConCodDoc}                      
                      type="text"
                      
                      autoComplete="off"
                      className="form-control block w-full px-1 py-1 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="w-2/3  ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Descripción
                  </label>
                  <div className="">
                    <select
                    onChange={handleOnsubmitDescripcion}
                    value={selectDescripcion}
                      className="form-select block  w-full px-1 py-1 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                        <option  >Sin seleccionar</option>
                    {
                        dataDescripcion.map((item)=>(
                            <option key={item.ConCodDoc}>{item.ConCodDoc}-{item.ConDesDoc}</option>
                        ))
                    }
                      
                    </select>
                  </div>
                </div>
              </div>
              
            
            <div className="px-2">
              <textarea
                value={informacionConsentimiento.ConDesDoc}
                disabled={true}
                className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-700  bg-white bg-clip-padding border border-solid border-gray-300 rounded
                        transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                id="exampleFormControlTextarea1"
                rows="3"
                placeholder=""
              ></textarea>
            </div>
            <div className="px-2 pt-2">
              <textarea
                onChange={handleOnchangeModificar}
                value={textConsentimiento}
                className="form-control block w-full px-3 py-1.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                        transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                id="exampleFormControlTextarea1"
                rows="8"
                placeholder=""
              ></textarea>
            </div>
          </div>

          <div className="flex justify-between items-center p-2 border-t border-gray-200 rounded-b-md">
          <div>
          {/* <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button> */}
          </div>
          <div className="text-right ">
          {/* <button
              type="button"
              onClick={handleClickFirmaPaciente}
              className="inline-block mr-2 px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Firma Paciente
            </button>      */}
            {/* <button
              type="button"
              onClick={handleClickFirmaAcudiente}
              className="inline-block mr-2 px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Firma Acudiente
            </button>        */}
            {/* <button
              type="button"
              onClick={handleClickFirmaMedico}
              className="inline-block mr-2 px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Firma Medico
            </button>    */}
            {/* <button
              type="button"
              onClick={handleClickFirmaOtro}
              className="inline-block mr-2 px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Firma Otro
            </button>       */}
            {/* <PDFDownloadLink document={<ConsentimientoPDF informacion={textConsentimiento} titulo={informacionConsentimiento.ConDesDoc} arrayFirmas={arrayFirmas}/>} fileName="consentimientoInformadoollllllllll.pdf"> */}
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
                <button
                  //type="button"
                  onClick={handleOnclickGuardarConsentimientoInformado}
                  className="inline-block mx-2 px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out "
                >
                  Guardar
                </button>
             {/* </PDFDownloadLink> */}
            </div>
          </div>
        </div>
      </div>
      {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }
      {/* {modalOnFirma? <ModalFirmaConsentimientoInformado setmodalOnFirma={setmodalOnFirma} informacion={textConsentimiento} titulo={informacionConsentimiento.ConDesDoc} setarrayFirmas={setarrayFirmas} nombreQuienFirma={nombreQuienFirma} tagFirma={tagFirma}/>:null} */}
    </div>
  );
};

export default ModalConsentimientoInformado;
